
"use client";

import React, { createContext, useState, useContext, ReactNode } from 'react';
import { ModalContextType, ViewableItem } from '../types/types';

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const ModalProvider = ({ children }: { children: ReactNode }) => {
  const [viewingItem, setViewingItem] = useState<ViewableItem | null>(null);
  const [interactionKey, setInteractionKey] = useState(0);

  const openProductModal = (item: ViewableItem) => {
    setViewingItem(item);
  };

  const closeProductModal = () => {
    setViewingItem(null);
    if (viewingItem && 'product' in viewingItem) {
      setInteractionKey(prev => prev + 1);
    }
  };

  return (
    <ModalContext.Provider value={{ 
      viewingItem, 
      interactionKey,
      openProductModal, 
      closeProductModal
    }}>
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => {
  const context = useContext(ModalContext);
  if (context === undefined) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};